export function disableForm(form) {
  form.querySelectorAll('button').forEach(button => button.setAttribute('disabled', ''))
}

export function enableForm(form) {
  form.querySelectorAll('button').forEach(button => button.removeAttribute('disabled'))
}

export function setFlash (type, message) {
  const flashContainer = document.querySelector('#flashes')

  if (!flashContainer) {
    console.error("Flash container not found")
    return  
  }

  const currentFlashMessages = Array.from(flashContainer.querySelectorAll('.nada-flash-message')).map(flash => flash.innerHTML)

  if (!currentFlashMessages.includes(message)) {
    const flash = document.createElement('div')
    flash.className = `nada-flash-message relative p-3 px-6 mb-2 border-2 border-(--flash-notice-border-color) bg-white ${type}`
    flash.textContent = message
    flash.setAttribute("data-toast-target", "toast")

    flashContainer.appendChild(flash)
  }
}